







import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";

@Component
export default class CompanyLowWarnings extends AbpBase {
  tableHeight=100;
  list=[];
  async getEquipmentCount(){
   let list = await this.$store.dispatch({
      type: "thequipment/getCountHomeEchart",
    });
    for(var i=0;i<list.length;i++){
      this.list.push({cName:list[i].fname,lowcount:list[i].didianliangCount})
    }
  }
  created() {
    this.getEquipmentCount();
  }

  mounted() { 
    this.tableHeight=this.$refs.refwarningmain.offsetHeight-50;
  }
  columns1= [
    {
      title: "企业名称",
      key: "cName",
    },
    {
      title: "设备数量",
      key: "lowcount",
    }
  ]
}
